import { createBlankTransaction } from './createBlankTransaction'
import type {
  CreateTransactionsByCategoryActionParameters,
  CreateTransactionsByCategoryActionReturnTypes,
} from './types'

type CreateTransactionsByIgnoreActionParameters =
  CreateTransactionsByCategoryActionParameters

type CreateTransactionsByIgnoreActionReturnTypes =
  CreateTransactionsByCategoryActionReturnTypes

export const createTransactionsByIgnoreAction = ({
  actionId,
  action,
  loans,
  crossActionBundles,
  assetBalances,
  assetBorrows,
  usedBalances,
  isLocked = false,
}: CreateTransactionsByIgnoreActionParameters): CreateTransactionsByIgnoreActionReturnTypes => {
  if (isLocked) {
    return {
      transactions: [],
      loans,
      crossActionBundles,
      assetBalances,
      assetBorrows,
      usedBalances,
    }
  }

  const result = createBlankTransaction({
    actionId,
    timestamp: action.timestamp,
    assetBalances,
    assetBorrows,
    usedBalances,
  })

  return {
    transactions: [result.transaction],
    loans,
    crossActionBundles,
    assetBalances: result.assetBalances,
    assetBorrows: result.assetBorrows,
    usedBalances: result.usedBalances,
  }
}
